/**
 * Performs a deep equality comparison between two values.
 * @param {*} a - First value to compare
 * @param {*} b - Second value to compare
 * @returns {boolean} - True if values are deeply equal, false otherwise
 */
export const deepEquals = (a, b) => {
  if (a === b) return true;
  if (a == null || b == null) return a === b;
  if (typeof a !== typeof b) return false;
  if (Array.isArray(a)) {
    if (!Array.isArray(b) || a.length !== b.length) return false;
    // Use for loop instead of every() to properly handle sparse array holes
    for (let i = 0; i < a.length; i++) {
      const aHasIndex = Object.prototype.hasOwnProperty.call(a, i);
      const bHasIndex = Object.prototype.hasOwnProperty.call(b, i);
      // Both must have or both must not have the index (hole)
      if (aHasIndex !== bHasIndex) return false;
      // If both have the index, compare values
      if (aHasIndex && !deepEquals(a[i], b[i])) return false;
    }
    return true;
  }
  if (typeof a === 'object') {
    // Ensure both are plain objects (not one array and one object)
    if (Array.isArray(b)) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    // Check all keys from a exist in b (order doesn't matter for object keys)
    if (!keysA.every(key => keysB.includes(key))) return false;
    return keysA.every(key => deepEquals(a[key], b[key]));
  }
  return false;
};

export default deepEquals;
